/*
 app dependencies
 - var body

 lib dependencies
*/

const scStatementVote = (function($)
{

	const _btns = document.querySelectorAll('.js-check-statement-vote');

	let _isAjaxing = false;

	//module functions
	function init()
	{
		Array.from(_btns).forEach(function(btn)
		{
			btn.addEventListener('click', function(e)
			{
				e.preventDefault();

				//login check
                if (!scState.isLoggedIn)
                {
                    scUi.loginPopup('<p>Hiervoor moet u inloggen.</p>');
                    return;
                }

				if (!_isAjaxing)
				{
					doAjax({
						ajaxUrl: `/ajax/do-vote/${this.dataset.factSlug}`,
						onSuccess: _onVoteSuccess,
						onError: _onVoteError,
						params: {
							btn
						}
					});
					_isAjaxing = true;
				}
			});
		});
	}

		function _onVoteSuccess(rawResponse, params)
		{
			_isAjaxing = false;

			try
			{
				var response = $.parseJSON(rawResponse);
				if (response.success)
				{
					_update(params.btn, String(response.votes), response.votedByUser);
				}
				else throw new Error(response.message);
			}
			catch (err) { lmnDialog.alert({ title: 'Foutmelding', body: err.message }); }
		}

			function _update(btn, votes, votedByUser)
			{
				if (!btn) return;
				btn.querySelector('.js-check-statement-vote__count').textContent = votes;
				if (votedByUser)
				{
					btn.classList.add('check-statement-vote--voted-by-user');
				}
				else
				{
					btn.classList.remove('check-statement-vote--voted-by-user')
				}
			}


		function _onVoteError(jqxhr, textStatus, errorThrown, params)
		{
			_isAjaxing = false;
			//error?
			if (!userAbortedAjax(jqxhr)) lmnDialog.alert({ title: 'Foutmelding', body: errorThrown });
		}

	function onPageLoad(elementId, votes, votedByUser)
	{
		_update(document.querySelector(`#${elementId}`), String(votes), votedByUser);
	}

	//reveal public vars and functions
	return {
		//vars

		//functions
		init,
		onPageLoad
	};

})(jQuery);
